function findFirstByValueAndProperty(list, value, property) {
    let res = {}

    for (let i=0; i<list.length; i++) {
        if (list[i][property] == value) {
            res = list[i]
            break
        }
    }

    return res
}

export function findFirstBySerialNum(list, num) {
    return findFirstByValueAndProperty(list, num, "serialNum")
}

export function findFirstByName(list, name) {
    return findFirstByValueAndProperty(list, name, "name")
}

export function findFirstByCode(list, code) {
    return findFirstByValueAndProperty(list, code, "code")
}

export function findFirstById(list, id) {
    return findFirstByValueAndProperty(list, id, "id")
}
